import React, {useState, useEffect} from 'react';
import {NavLink} from "react-router-dom";
import {useDispatch} from "react-redux";

import styles from './Header.module.scss';
import Logo from "../../assets/images/teamtop_logo.png";
import IconBookmark from "../../assets/images/icon_bookmark.png";

import {CONFIG_HEADER, MOBILE_VIEW_TABLET} from "../../shared/constants";
import {enableScrolling, disableScrolling} from "../../shared/helpers";
import NavMobile from "../NavMobile/NavMobile";
import Nav from "../Nav/Nav";
import ContextMenu from "../ContextMenu/ContextMenu";
import DropDown from "../DropDown/DropDown";
import {clearSelectedOffer} from "../../redux/rootReducer";
import PopupBookmark from '../PopupBookmark/PopupBookmark';

const Header = ({
    currentLanguage,
    setCurrentLanguage,
    windowSize,
    config,
    player,
    logout
}) => {
    const dispatch = useDispatch();
    const [isBookmarkVisible, setIsBookmarkVisible] = useState(false);
    const [isPopupBookmarkOpen, setIsPopupBookmarkOpen] = useState(false);
    const navigation = windowSize.isMobileView ?
        <NavMobile menus={config.menus} />
        :
        <Nav menus={config.menus} />

    const unselectOffer = () => {
        dispatch(clearSelectedOffer());
    }

    const openPopupBookmark = () => {
        disableScrolling();
        setIsPopupBookmarkOpen(true);
    }

    const closePopupBookmark = () => {
        enableScrolling();
        setIsPopupBookmarkOpen(false);
    }

    return (
        <header className={styles.headerWrapper}>
            <div className={styles.innerWrapper}>
                {CONFIG_HEADER.hasNavigation ?
                    navigation
                    :
                    null
                }
                {CONFIG_HEADER.hasLogo ?
                    <NavLink to={'/shop'} onClick={() => {
                        unselectOffer();
                        window.scrollTo(0, 0);
                    }}>
                        <img src={Logo} className={styles.logo} alt={''} />
                    </NavLink>
                    :
                    null
                }
                {CONFIG_HEADER.hasTitle ?
                    windowSize.width < MOBILE_VIEW_TABLET ?
                        null
                        :
                        <div className={styles.name}>{config.headerTitle}</div>
                    :
                    null
                }
                {CONFIG_HEADER.hasLanguages ?
                    <DropDown currentLanguage={currentLanguage} setCurrentLanguage={setCurrentLanguage} />
                    :
                    null
                }
                {CONFIG_HEADER.hasContextMenu ?
                    <div className={styles.iconAndContextWrapper}>
                        <img
                            className={styles.iconBookmark}
                            src={IconBookmark}
                            alt='bookmark'
                            onClick={openPopupBookmark}
                        />
                        <div className={styles.contextMenuWrapper}>
                            <ContextMenu
                                config={config}
                                name={player.username}
                                id={player.userId}
                                isMobileView={windowSize.isMobileView}
                                logout={logout}
                            />
                        </div>
                    </div>
                    :
                    null
                }
            </div>
            {isPopupBookmarkOpen ? <PopupBookmark windowSize={windowSize} closePopupBookmark={closePopupBookmark} /> : null}
        </header>
    );
};

export default Header;